import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';
import { ImportModalComponent } from 'components/RootModal/modalRegistry';
import { Map as ImmutableMap } from 'immutable';

import type { GeneratorDialogProps } from './types';

const GENERATOR_DIALOG = 'GENERATOR_DIALOG';
ImportModalComponent(GENERATOR_DIALOG, () => import('./index'));

export const dispatchGeneratorDialog = (props?: GeneratorDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: GENERATOR_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchGeneratorDialog;
